import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";

const LostWalletAssistance = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const RestorationProActiveServices = useAreServicesActive([ezsServiceIds.businessIdRestorationPro]);

    return (
        <React.Fragment>
            <div className="box box-border-top">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon position-right" aria-hidden="true">
                            <RenderIcons iconName="wallet" />
                        </div>
                        <div className="box-title-text">
                            <h3 className="box-title">{tLang("dashboard.lostWalletWidget.title")}</h3>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    {RestorationProActiveServices && <p> {tLang("dashboard.lostWalletWidget.newmessage")}</p>}
                    {!RestorationProActiveServices && <p> {tLang("dashboard.lostWalletWidget.message")}</p>}
                    <p className="text-align-center">
                        <Link to="/identity-vault/secure-storage" type="button" className="btn-default btn-secondary-outline bit-btn">
                            <span className="btn-text">{tLang("dashboard.lostWalletWidget.viewWalletButton")}</span>
                        </Link>
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LostWalletAssistance;
